export default __webpack_public_path__ + "static/media/buysellapp_logo.9d3ac238.png";